// extracted by mini-css-extract-plugin
export default {"detailContainer":"styles_detailContainer__Y-2wg","icon":"styles_icon__j+LPx"};